export default "__VITE_ASSET__DgXsdpuN__"